import { createActions, createReducer } from 'reduxsauce'
import moment from 'moment'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  dashboardOrders: {},
  loading: false,
  error: null,
  orderStartAt: Number(
    moment()
      .startOf('day')
      .format('x')
  ),
  orderEndAt: Number(
    moment()
      .endOf('day')
      .format('x')
  ),

  dashboardCustomers: {},
  dashboardCustomersLoading: false,

  payingCustomers: {},
  payingCustomersLoading: false,

  expressOrders: {},
  expressOrderLoaded: false,
})

const { Types, Creators } = createActions({
  setOrderStartEndAt: ['field', 'date'],

  getOrderByDate: ['start', 'end'],
  getOrderByDateSuccess: ['orders'],
  getOrderByDateFailure: ['error'],

  getCustomersByDate: ['startAt', 'endAt'],
  setDashboardCustomerLoading: ['val'],
  setDashboardCustomers: ['customers'],

  getPayingCustomers: null,
  getPayingCustomersSuccess: ['payingType', 'customers'],

  getExpressOrders: ['startAt', 'endAt'],
  setExpressOrders: ['data'],
  setExpressOrderError: ['error'],
})

const getOrderByDateReducer = state => state.set('loading', true)

const getOrderByDateSuccessReducer = (state, { orders }) =>
  state
    .set('loading', false)
    .set('dashboardOrders', orders)
    .set('error', {})

const getOrderByDateFailureReducer = (state, { error }) =>
  state
    .set('loading', false)
    .set('dashboardOrders', {})
    .set('error', error)

const getPayingCustomersReducer = state => state.set('payingCustomersLoading', true)

const getPayingCustomersSuccessReducer = (state, { payingType, customers }) =>
  state.set('payingCustomersLoading', false).setIn(['payingCustomers', payingType], customers)

const setOrderStartEndAtReducer = (state, { field, date }) => state.set(field, date)

const setDashboardCustomerLoadingReducer = (state, { val }) => state.set('dashboardCustomersLoading', val)
const setDashboardCustomersReducer = (state, { customers }) => state.set('dashboardCustomers', customers)

const getExpressOrdersReducer = state => state.set('expressOrderLoaded', false)
const setExpressOrdersReducer = (state, { data }) =>
  state.set('expressOrderLoaded', true).set('expressOrders', data)
const setDashboardCustomerErrorReducer = state => state.set('expressOrders', {}).set('expressLoaded', false)

export const dashboardReducer = createReducer(INITIAL_STATE, {
  [Types.SET_ORDER_START_END_AT]: setOrderStartEndAtReducer,

  [Types.GET_ORDER_BY_DATE]: getOrderByDateReducer,
  [Types.GET_ORDER_BY_DATE_SUCCESS]: getOrderByDateSuccessReducer,
  [Types.GET_ORDER_BY_DATE_FAILURE]: getOrderByDateFailureReducer,

  [Types.GET_PAYING_CUSTOMERS]: getPayingCustomersReducer,
  [Types.GET_PAYING_CUSTOMERS_SUCCESS]: getPayingCustomersSuccessReducer,
  [Types.SET_DASHBOARD_CUSTOMER_LOADING]: setDashboardCustomerLoadingReducer,
  [Types.SET_DASHBOARD_CUSTOMERS]: setDashboardCustomersReducer,

  [Types.GET_EXPRESS_ORDERS]: getExpressOrdersReducer,
  [Types.SET_EXPRESS_ORDERS]: setExpressOrdersReducer,
  [Types.SET_EXPRESS_ORDER_ERROR]: setDashboardCustomerErrorReducer,
})

export const DashboardTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/dashboardReducer.js